import { ReactElement, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Select } from '~/components/NewSelect';
import { getUserProfile } from '~/helpers/userProfile';
import { apiCall, ApiResps } from '~/providers';
import { EditClientFormValues } from '../Form/types';
import { ContainerSelect } from '../../styles';

type PartnerClient = ApiResps['/clients/get-clients-list']['list'][number];

const CLIENT_TYPE_OPTIONS = [
  { label: 'Cliente', value: 'cliente' },
  { label: 'Mantenedor', value: 'mantenedor' },
  { label: 'Fabricante', value: 'fabricante' },
  { label: 'Parceira', value: 'parceira' },
  { label: 'Sub-Cliente', value: 'sub-cliente' },
];

export function SelectClientType({
  disabled,
}: Readonly<{
  disabled: boolean
}>): ReactElement | null {
  const { t } = useTranslation();
  const profile = getUserProfile();
  const { control, setValue } = useFormContext<EditClientFormValues>();
  const [partnerClients, setPartnerClients] = useState<PartnerClient[]>([]);

  const clientTypeWatch = useWatch({ control, name: 'clientType' });
  const clientOwnerWatch = useWatch({ control, name: 'clientOwner' });

  useEffect(() => {
    if (profile.permissions.isAdminConta) return;
    apiCall('/clients/get-clients-list', {})
      .then(({ list }) => {
        setPartnerClients(list.filter((x) => x.PERMS_C?.includes('[ADMC]')));
      })
      .catch(console.error);
  }, []);

  if (profile.permissions.isAdminConta) return null;

  return (
    <ContainerSelect>
      <Select
        label={t('tipoCadastro')}
        options={CLIENT_TYPE_OPTIONS}
        propLabel="label"
        value={CLIENT_TYPE_OPTIONS.find((opt) => opt.value === clientTypeWatch) ?? null}
        onSelect={(item) => setValue('clientType', item.value)}
        disabled={disabled}
      />
      {clientTypeWatch === 'sub-cliente' && (
        <Select
          label={t('empresaMae')}
          options={partnerClients}
          propLabel="NAME"
          value={partnerClients.find((c) => c.CLIENT_ID === clientOwnerWatch) ?? null}
          onSelect={(item) => setValue('clientOwner', item.CLIENT_ID)}
          disabled={disabled}
        />
      )}
    </ContainerSelect>
  );
}
